export default (siteName) => [
    {
        path: '/:company_id/setup',
        component: () => import('../components/Setup/SetupWrapperView.vue'),
        redirect: '/:company_id/setup/start',
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: 'start',
                name: 'setup-start',
                component: () => import('../components/Setup/Start.vue'),
                meta: {
                    title: `初始設定-開始${siteName}`,
                },
            },
            {
                path: 'staff',
                name: 'setup-staff',
                component: () => import('../components/Setup/Staff.vue'),
                meta: {
                    title: `初始設定-員工管理${siteName}`,
                },
            },
            {
                path: 'bank',
                name: 'setup-bank',
                component: () => import('../components/Setup/Bank.vue'),
                meta: {
                    title: `初始設定-銀行帳戶${siteName}`,
                },
            },
            {
                path: 'statement',
                name: 'setup-statement',
                component: () => import('../components/Setup/Statement.vue'),
                meta: {
                    title: `初始設定-收支項目${siteName}`,
                },
            },
            {
                path: 'audit',
                name: 'setup-audit',
                component: () => import('../components/Setup/Audit.vue'),
                meta: {
                    title: `初始設定-審核流程${siteName}`,
                },
            },
            {
                path: 'finish',
                name: 'setup-finish',
                component: () => import('../components/Setup/Finish.vue'),
                meta: {
                    title: `初始設定-完成${siteName}`,
                },
            },
        ],
    },
];
